var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 29,
  rx: 14.5,
  stroke: "black"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.909 7.5947V9.99461H17.4374C16.8706 9.99461 16.5106 10.1003 16.3582 10.3105C16.162 10.542 16.064 10.8689 16.064 11.2893V12.9951H18.8109L18.4509 15.6791H16.064V22.5H13.219V15.6791H10.832V12.9951H13.219V11.0369C13.219 9.94206 13.5353 9.06895 14.1673 8.41585C14.843 7.80547 15.7154 7.5 16.7833 7.5C17.6772 7.5 18.3858 7.53176 18.909 7.5947Z",
  fill: "black"
})));
export default SvgIconFacebook;